(function($){
  if (!$) { return; }

  // Hide the quantity-selector box in the collection-page quick-view popup
  // for specific products (currently only "C'est facile!", handle: cest-facile).
  var HIDE_QTY_HANDLES = ['cest-facile'];

  function shouldHideForValue(val){
    if (!val) { return false; }
    for (var i = 0; i < HIDE_QTY_HANDLES.length; i++){
      var re = new RegExp('/products/' + HIDE_QTY_HANDLES[i] + '(?:[/?]|$)');
      if (re.test(val)) { return true; }
    }
    return false;
  }

  $(document).on('click', '.tt-btn-quickview', function(){
    window.__qvHideQty = shouldHideForValue($(this).attr('data-value'));
  });

  function applyQtyVisibility(){
    var $counter = $('#ModalquickView .tt-input-counter').first();
    if (!$counter.length) { return; }
    var $wrap = $counter.closest('.col-item');
    if (!$wrap.length) { $wrap = $counter; }
    $wrap.toggle(!window.__qvHideQty);
  }

  $(document).on('shown.bs.modal', '#ModalquickView', applyQtyVisibility);

  $(function(){
    var target = document.getElementById('ModalquickView');
    if (!target || !window.MutationObserver) { return; }
    var mo = new MutationObserver(applyQtyVisibility);
    mo.observe(target, { childList: true, subtree: true, characterData: true });
  });
})(window.jQuery);
